import type { ToasterProps } from 'vue-sonner'

const toastConfig: ToasterProps = {
  position: 'bottom-right',
  toastOptions: {
    classes: {
      success: 'text-text-success bg-background-success-subtle border-border-success',
      error: 'text-text-danger bg-background-danger-subtle border-border-danger',
      warning: 'text-text-warning bg-background-warning-subtle border-border-warning',
      info: 'text-text-primary bg-background-primary-subtle border-border-primary',
    },
  },
}

export default toastConfig
